import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {classNames} from 'primereact/utils';
import {Button} from 'primereact/button';
import {Panel} from "primereact/panel";
import {addLocale} from 'primereact/api';
import {Dropdown} from "primereact/dropdown";
import {AutoComplete} from "primereact/autocomplete";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {InputNumber} from "primereact/inputnumber";

import PurchaseorderrequestFormService from '../_services/purchaseorderrequest/PurchaseorderrequestFormService'
import ProjectListService from "../_services/project/ProjectListService";
import ProductListService from "../_services/product/ProductListService";
import PurchaseorderrequestShowService from "../_services/purchaseorderrequest/PurchaseorderrequestShowService";
import PurchaseorderRequestToOrderService from "../_services/purchaseorder/PurchaseorderRequestToOrderService";
import UserListService from "../_services/user/UserListService";
import PurchaseorderrequestItemDeleteService
  from "../_services/purchaseorderrequest/PurchaseorderrequestItemDeleteService"
import InventoryListService from "../_services/inventory/InventoryListService";
import currencyFormatter from "currency-formatter";
import {InputMask} from "primereact/inputmask";
import PurchaseorderrequestItemSaveService
  from "../_services/purchaseorderrequest/PurchaseorderrequestItemSaveService";

const PurchaseorderrequestFormComponent = (props) => {

  const {t} = props;
  const [formData, setFormData] = useState({
    project: {id: Number(localStorage.getItem('defaultProjectId'))},
  });
  const [loading, setLoading] = useState(false);
  const [productExpandedRows, setProductExpandedRows] = useState(null);
  const [orderExpandedRows, setOrderExpandedRows] = useState(null);
  const [productInventory, setProductInventory] = useState([]);
  const [orderStock, setOrderStock] = useState(0);

  const validate = (data) => {
    let errors = {};
    return errors;
  };

  const onSubmit = (data, form) => {
    setLoading(true)
    setFormData({
      ...formData,
      data
    });
    if ((props && props.initialValues) || (formData && formData.id)) {
      PurchaseorderrequestFormService(data, 'put')
        .then(response => {
          window.App.toastShow('success', 'Sikeres módosítás!');
          window.App.setState({rerenderPurchaseorderrequestList: true})
          if (props.closeForm === true) {
            window.App.setState({
              sidebarPurchaseorderrequestCreate: false,
              sidebarPurchaseorderrequestUpdate: false,
            })
          }
          setLoading(false)
          setFormData(response.data)
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
          setLoading(false)
        })
    } else {
      PurchaseorderrequestFormService(data, 'post')
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderPurchaseorderrequestList: true})
          if (props.closeForm === true) {
            window.App.setState({
              sidebarPurchaseorderrequestCreate: false,
              sidebarPurchaseorderrequestUpdate: false,
            })
          }
          setFormData(response.data)
          setLoading(false)
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
          setLoading(false)
        })
    }
    form.restart();

  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  // project autocomplete
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(localStorage.getItem('defaultProjectName'));

  const searchProject = (event) => {
    ProjectListService(JSON.stringify({filters: {name: {value: event.query}}}))
      .then(response => {
        setProjects(response.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      })
  }

  // product list
  const [products, setProducts] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1
  });
  const dt = useRef(null);

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoadingProducts(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      //window.App.setState({rerenderGuestList: false})
      ProductListService(JSON.stringify(lazyParams))
        .then(response => {
          setTotalRecords(response.data.total_item_count);
          setProducts(response.data.items);
          setLoadingProducts(false);
          response.data.items.map(function (item, index) {
            if (document.getElementById('amount' + item.id)) {
              document.getElementById('amount' + item.id).children[0].value = ''
            }
          })
        });
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  // user autocomplete
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');

  const searchUsers = (event) => {
    UserListService(JSON.stringify({filters: {name: {value: event.query}}}))
      .then(response => {
        setUsers(response.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      })
  }

  const productRowExpansionTemplate = (data) => {
    return (
      <>
        <div className="p-ml-3">
          <h3 className={"p-mt-0 p-pt-0"}>Aktuális készlet</h3>
          <DataTable size={localStorage.getItem('scale')} value={productInventory[data.id]}
                     emptyMessage="Nincs találat."
                     autoLayout={true}
                     filterDisplay="row"
                     responsiveLayout="scroll"
                     stripedRows
          >
            <Column field="warehouseName" header="Raktár" filter sortable filterPlaceholder="Raktár"></Column>
            <Column field="stock" header="Mennyiség" filter sortable className={"p-text-right"} alignHeader="right"
                    filterPlaceholder="Mennyiség"
                    body={(rowData) => {
                      return (
                        <>{rowData.stock} {data.unitName}</>
                      )
                    }}
            ></Column>
          </DataTable>
        </div>
      </>
    );
  }

  const orderRowExpansionTemplate = (data) => {
    return (
      <>
        <div className="p-ml-3">
          <h3 className={"p-mt-0 p-pt-0"}>Készlet foglalás</h3>
          <DataTable size={localStorage.getItem('scale')} value={orderStock}
                     emptyMessage="Nincs találat."
                     autoLayout={true}
                     filterDisplay="row"
                     responsiveLayout="scroll"
                     stripedRows
          >
            <Column field="warehouseName" header="Raktár" filter sortable filterPlaceholder="Raktár"></Column>
            <Column field="stock" header="Mennyiség" filter sortable className={"p-text-right"} alignHeader="right"
                    filterPlaceholder="Mennyiség"
                    body={(rowData) => {
                      return (
                        <>{rowData.stock} {data.unitName}</>
                      )
                    }}
            ></Column>
            <Column body={(rowData, row) => {
              return (
                <div className="p-inputgroup">
                  <InputNumber
                    id={"amountOrder" + rowData.id}
                    className={"amount"}
                    locale="hu-HU"
                    minFractionDigits={0}
                    maxFractionDigits={9}
                  />
                  <Button type="button" icon="pi pi-check" className="p-button-success" disabled={loading}
                          onClick={(e) => {
                            setLoading(true)
                            PurchaseorderrequestItemSaveService(formData.id, rowData.id, document.getElementById('amountOrder' + rowData.id).children[0].value, rowData.warehouse.id)
                              .then(response => {
                                document.getElementById('amountOrder' + rowData.id).children[0].value = ''
                                PurchaseorderrequestShowService(props.initialValues.id)
                                  .then(response => {
                                    setSelectedProject(response.data.projectName)
                                    setFormData(response.data)
                                    setLoading(false)
                                  })
                                  .catch(error => {
                                    window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
                                  })
                              })
                              .catch(error => {
                                window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
                                setLoading(false)
                              })
                          }}/>
                </div>
              )
            }}></Column>
          </DataTable>

        </div>
      </>
    );
  }

  useEffect(() => {
    if (localStorage.getItem('userId')) {
      setFormData({
        ...formData,
        requestedBy: {id: Number(localStorage.getItem('userId'))}
      })
      setSelectedUser(localStorage.getItem('userRealName'))
    }
    if (props && props.initialValues) {
      PurchaseorderrequestShowService(props.initialValues.id)
        .then(response => {
          setSelectedProject(response.data.projectName)
          setFormData(response.data)
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        })
    }
    loadLazyData();
  }, [lazyParams])

  return (
    <Form onSubmit={onSubmit} initialValues={formData}
          validate={validate} render={({handleSubmit}) => (
      <form onSubmit={handleSubmit} className="PurchaseorderrequestForm">
        <div className={"p-grid p-d-flex p-flex-wrap p-mt-3"}>
          <div className={"p-col-12 p-xl-12 p-d-flex"}>
            <Panel headerTemplate={
              <div className={"p-grid"}>
                <div className={"p-col-12"}>
                  <h3>
                    <i className={"pi pi-list"}></i> Alapadatok
                  </h3>
                </div>
              </div>
            } className={"w-100"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6"}>
                  <Field name="project" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="project"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('project')}</label>
                      <span className="p-d-block">
                    <AutoComplete value={selectedProject}
                                  id={"project"}
                                  suggestions={projects}
                                  forceSelection
                                  completeMethod={searchProject}
                                  field={"name"}
                                  delay="1000"
                                  dropdown
                                  placeholder={"Keresés gépeléssel..."}
                                  className={classNames({'p-invalid': isFormFieldValid(meta)})}
                                  onSelect={(e) => {
                                    setFormData({
                                      ...formData,
                                      project: {id: e.value.id}
                                    })
                                    localStorage.setItem("defaultProjectId", e.value.id)
                                    localStorage.setItem("defaultProjectName", e.value.name)
                                  }}
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      project: {id: null}
                                    })
                                    setSelectedProject(e.value)
                                  }}
                                  onClear={(e) => {
                                    setSelectedProject('')
                                  }}
                    />
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-1"}>
                  <Field name="deadline" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="deadline"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>Határidő</label>
                      <span className="p-d-block">
                        <InputMask id={"deadline"}
                                   mask={"9999-99-99"}
                                   placeholder={"ÉÉÉÉ-HH-NN"}
                                   value={formData.deadline}
                                   onChange={(e) => {
                                     if (e.value.indexOf("_") === -1) {
                                       if (e.value === '') {
                                         e.value = null
                                       }
                                       setFormData({
                                         ...formData,
                                         deadline: e.value
                                       })
                                     }
                                   }}
                        />
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col"}>
                  <Field name="requestedBy" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="requestedBy"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>Igénylő</label>
                      <span className="p-d-block">
                        {localStorage.getItem('roles').toString().includes('role_user_browse')
                        || localStorage.getItem('roles').toString().includes('role_user_read') ? (
                          <AutoComplete value={selectedUser}
                                        id={"requestedBy"}
                                        suggestions={users}
                                        forceSelection
                                        completeMethod={searchUsers}
                                        field={"name"}
                                        delay="1000"
                                        placeholder={"Keresés gépeléssel..."}
                                        className={classNames({'p-invalid': isFormFieldValid(meta)})}
                                        onSelect={(e) => {
                                          setFormData({
                                            ...formData,
                                            requestedBy: {id: e.value.id}
                                          })
                                        }}
                                        onChange={(e) => {
                                          setFormData({
                                            ...formData,
                                            requestedBy: {id: null}
                                          })
                                          setSelectedUser(e.value)
                                        }}
                                        dropdown
                                        onClear={(e) => {
                                          setSelectedUser('')
                                        }}
                          />
                        ) : (
                          <Dropdown disabled className={"disabled"} id={"requestedBy"}/>
                        )}
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                {/*<div className={"p-col-12 p-md-12 p-lg-12"}>*/}
                {/*  <Field name="status" render={({input, meta}) => (*/}
                {/*    <div className="p-field p-fluid">*/}
                {/*      <label htmlFor="status"*/}
                {/*             className={classNames({'p-error': isFormFieldValid(meta)})}>Státusz</label>*/}
                {/*      <span>*/}
                {/*            <Dropdown options={statuses}*/}
                {/*                      optionLabel="name"*/}
                {/*                      optionValue="id"*/}
                {/*                      id={"status"}*/}
                {/*                      emptyMessage={"Még nincs státusz..."}*/}
                {/*                      onChange={(e) => {*/}
                {/*                        setFormData({*/}
                {/*                          ...formData,*/}
                {/*                          status: e.value*/}
                {/*                        })*/}
                {/*                      }}*/}
                {/*                      value={formData.status}*/}
                {/*            />*/}
                {/*  </span>*/}
                {/*      {getFormErrorMessage(meta)}*/}
                {/*    </div>*/}
                {/*  )}/>*/}
                {/*</div>*/}
              </div>
            </Panel>
          </div>

          <div className={"p-col-12 p-xl-12 p-d-flex"}>
            <Panel className={"w-100"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-8 p-xl-8"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12"}>
                      <h3>
                        <i className={"pi pi-list"}></i> Kiválasztható termékek
                      </h3>
                    </div>
                  </div>
                  {formData && formData.id ? (
                    <>
                      <DataTable size={localStorage.getItem('scale')}
                        id={"selectable"}
                        emptyMessage="Nincs találat."
                        value={products} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                        onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                        onFilter={onFilter} filters={lazyParams.filters} loading={loadingProducts} lazy
                        paginatorTemplate={pager} rows={rows}
                        autoLayout={true}
                        ref={dt}
                        filterDisplay="row"
                        responsiveLayout="scroll"
                        stripedRows
                        dataKey="id"
                        rowExpansionTemplate={productRowExpansionTemplate}
                        expandedRows={productExpandedRows}
                        onRowExpand={(e) => {
                          InventoryListService(JSON.stringify({
                            first: 0,
                            rows: 9999,
                            page: 0,
                            sortField: 'id',
                            sortOrder: -1,
                            filters: {productName: {value: e.data.name}}
                          }))
                            .then(response => {
                              let _inventory = productInventory
                              _inventory[e.data.id] = response.data.items
                              setProductInventory(_inventory)
                            })
                            .catch(error => {
                              window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
                            })
                          setTimeout(function () {
                            setProductExpandedRows({[e.data.id]: true})
                          }, 1000)
                        }}
                        // onRowToggle={(e) => {
                        //   setProductExpandedRows(e.data)
                        // }}
                      >
                        <Column field="manufacturerName" header="Gyártó" sortable filter
                                filterPlaceholder="Gyártó"></Column>
                        <Column field="name" header="Név" sortable filter filterPlaceholder="Név"></Column>
                        <Column field="sku" header="Termék cikkszám (SKU)" sortable filter
                                filterPlaceholder="Termék cikkszám (SKU)"></Column>
                        <Column body={(rowData, row) => {
                          return (
                            <div className="p-inputgroup">
                              <InputNumber
                                id={"amount" + rowData.id}
                                className={"amount"}
                                locale="hu-HU"
                                minFractionDigits={0}
                                maxFractionDigits={9}
                              />
                              <Button type="button" icon="pi pi-check" className="p-button-success" disabled={loading}
                                      onClick={(e) => {
                                        if (e.target.parentElement.parentElement.children[0].children[0].getAttribute('aria-valuenow') !== null) {
                                          setLoading(true)
                                          let items = formData.items.filter(item => item.product !== rowData.id)
                                          let _items = [
                                            ...items,
                                            {
                                              quantity: Number(e.target.parentElement.parentElement.children[0].children[0].getAttribute('aria-valuenow')),
                                              product: rowData.id,
                                              productName: rowData.name
                                            }
                                          ]
                                          let data = {
                                            ...formData,
                                            items: _items
                                          }
                                          PurchaseorderrequestFormService(data, 'put')
                                            .then(response => {
                                              setFormData(response.data)
                                              setLoading(false)
                                              document.getElementById('amount' + rowData.id).children[0].value = ''
                                            })
                                            .catch(error => {
                                              window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
                                              setLoading(false)
                                            })
                                        }
                                      }}/>
                            </div>
                          )
                        }}></Column>
                        <Column field="unitName" header=""></Column>
                        <Column field="averagePurchaseUnitPrice" header="Átlag nettó beszer. ért." sortable
                                className={"p-text-right p-text-nowrap"}
                                alignHeader="right"
                                body={(rowData) => {
                                  let currency
                                  if (rowData.currency === 'HUF') {
                                    currency = {
                                      precision: 2,
                                      symbol: '',
                                      decimal: ',',
                                      thousand: ' ',
                                    }
                                  } else {
                                    currency = {
                                      precision: 2,
                                      symbol: '',
                                      decimal: '.',
                                      thousand: ' ',
                                    }
                                  }
                                  return (
                                    <>
                                      {currencyFormatter.format(
                                        rowData.averagePurchaseUnitPrice, {
                                          precision: currency.precision,
                                          symbol: currency.symbol,
                                          decimal: currency.decimal,
                                          thousand: currency.thousand,
                                        }
                                      )}&nbsp;{rowData.currency}
                                    </>
                                  )
                                }}></Column>
                        <Column expander style={{width: '3em'}}/>
                      </DataTable>
                    </>
                  ) : (
                    <><i className={"pi pi-lock"}></i> A termékek kiválasztása vagy importálása csak mentés után lehetséges!</>
                  )}
                </div>
                <div className={"p-col"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12"}>
                      <h3>
                        <i className={"pi pi-list"}></i> Rendelendő termékek
                      </h3>
                    </div>
                  </div>
                  {formData && formData.id ? (
                    <DataTable size={localStorage.getItem('scale')}
                      id={"selected"}
                      emptyMessage="Nincs találat."
                      value={formData.items}
                      autoLayout={true}
                      filterDisplay="row"
                      responsiveLayout="scroll"
                      stripedRows
                      loading={loading}
                      dataKey="id"
                      rowExpansionTemplate={orderRowExpansionTemplate}
                      expandedRows={orderExpandedRows}
                      onRowExpand={(e) => {
                        InventoryListService(JSON.stringify({
                          first: 0,
                          rows: 9999,
                          page: 0,
                          sortField: 'id',
                          sortOrder: -1,
                          filters: {productName: {value: e.data.productName}}
                        }))
                          .then(response => {
                            setOrderStock(response.data.items)
                          })
                          .catch(error => {
                            window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
                          })
                        setTimeout(function () {
                          setOrderExpandedRows({[e.data.id]: true})
                        }, 1000)
                      }}
                      >
                      <Column body={(rowData) => {
                        return (
                          <>
                            <Button icon="pi pi-trash" className="  p-button-danger"
                                    disabled={loading}
                                    tooltip="Törlés" tooltipOptions={{ position: 'left' }}
                                    type="button"
                                    onClick={() => {
                                      setLoading(true)
                                      PurchaseorderrequestItemDeleteService(formData.id, rowData.id)
                                        .then(response => {
                                          if (document.getElementById('amount' + rowData.product.id)) {
                                            document.getElementById('amount' + rowData.product.id).children[0].value = ''
                                          }
                                          setLoading(false)
                                          setFormData(response.data)
                                        })
                                        .catch(error => {
                                          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
                                        })
                                    }}
                            />
                          </>
                        )
                      }}></Column>
                      <Column field="productName" header="Név" sortable></Column>
                      <Column field="warehouseName" header="Raktárról" sortable></Column>
                      {/*<Column field="sku" header="Termék cikkszám (SKU)" sortable></Column>*/}
                      <Column field="quantity" header="Mennyiség" className={"p-text-right"} alignHeader="right" body={(rowData) => {
                        return (
                          <>
                            {currencyFormatter.format(
                              rowData.quantity, {
                                precision: 0,
                                symbol: '',
                                decimal: '.',
                                thousand: ' ',
                              }
                            )
                            }
                          </>
                        )
                      }}></Column>
                      <Column expander style={{width: '3em'}}/>
                    </DataTable>
                  ) : (
                    <><i className={"pi pi-lock"}></i> A termékek megtekintése csak mentés után lehetséges!</>
                  )}
                </div>
              </div>
              <div className={"p-grid p-mt-1"}>
                <div className={"p-col-12 p-lg-6 p-xl-6"}>

                </div>
                <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
                  {formData && formData.id ? (
                    <Button type="button" label="Importálás" icon={"pi pi-upload"} loading={loading}
                            onClick={() => {
                              window.App.setState({
                                sidebarPurchaseorderrequestImport: true,
                                props: formData
                              })
                            }}
                            className="p-button-success"/>
                  ):(
                    <Button type="button" label="Importálás" icon={"pi pi-upload"} loading={loading} disabled
                            className="p-button-success disabled"/>

                  )}
                </div>
              </div>
            </Panel>
          </div>
        </div>
        <div className={"p-grid p-mt-1"}>
          <div className={"p-col-12 p-lg-6 p-xl-6"}>
            {formData.id &&
            <Button type="button" label="Megtekintés" icon={"pi pi-eye"}
                    onClick={() => {
                      window.App.setState({
                        props: formData,
                        sidebarPurchaseorderrequestUpdate: false,
                        sidebarPurchaseorderrequestCreate: false,
                        sidebarPurchaseorderrequestShow: true,
                      })
                    }}
                    className="p-button"/>
            }
          </div>
          <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
            {formData && formData.id && formData.status === 'new' &&
            <Button type="button" label="Beszerzési megrendeléssé alakítás" loading={loading} icon={"pi pi-clone"}
                    onClick={() => {
                      PurchaseorderRequestToOrderService(formData.id)
                        .then(response => {
                          window.App.toastShow('success', 'Sikeres művelet', 'A megrendelés igény megrendelésként lett elmentve.');
                          window.App.setState({
                            sidebarPurchaseorderrequestCreate: false,
                            sidebarPurchaseorderrequestUpdate: false,
                            rerenderPurchaseorderrequestList: true,
                            sidebarPurchaseorderShow: true,
                            props: response.data
                          })
                        })
                        .catch(error => {
                          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
                        })
                    }}
                    className="p-button p-ml-2"/>}
            <Button type="submit" label="Mentés és bezár" icon={"pi pi-check"}
                    loading={loading}
                    onClick={() => {
                      props = {...props, closeForm: true}
                    }}
                    className="p-button-success  p-ml-2"/>
            <Button type="submit" label="Mentés" icon={"pi pi-check"}
                    loading={loading}
                    onClick={() => {
                      props = {...props, closeForm: false}
                    }}
                    className="p-button-success p-ml-2"/>
          </div>
        </div>
      </form>
    )}/>
  )
}
export default withTranslation('common')(PurchaseorderrequestFormComponent);
